/* eslint-disable */
import React from 'react'
import {Checkbox, Icon, message, Pagination, Radio} from 'antd'

import {Button, Container, MDBBreadcrumb, MDBBreadcrumbItem, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import jMoment from 'moment-jalaali'
// import {DatePicker} from "react-advance-jalaali-datepicker";
import http from '../../Component/Interceptor/Interseptor'
import moment from 'moment'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {Link} from 'react-router-dom'
import $ from 'jquery'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import InputMask from 'react-input-mask'
import Select from 'react-select'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {Helmet} from 'react-helmet'
import Loader from '../loaders/loader'
import {shopUrl} from '../BaseComponent/configTheme'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'
import ParcelSearch from '../BaseComponent/parcelSearch'
jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})
const RadioGroup = Radio.Group

class EditPreRecord extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      beepUrl: '/beep-06.mp3',
      wrongUrl: '/erro.mp3',
      init: true,
      lastEnteredProduct: {
        name: '',
        barcode: '',
        time: '',
        count: '',
        unit: ''
      },
      otherSellers: false,
      manualRegVal: null,
      selectedDate: null,
      selectedOption: null,
      providerValue: '',
      providers: [],
      refFactorVal: moment(),
      typeWarehouseId: '',
      typeDocId: '',
      isInput: '',
      refType: '',
      isInternal: false,
      abnormal: false,
      refWarehouseId: '',
      id: '',
      code: '',
      quantity: '',
      product: [],
      details: [],
      wareHousesname: [],
      docType: [],
      errorDocForm: '',
      addError: '',
      valueBarcode: 'barcodeOnly',
      fadeTable: 'true',
      visible: false,
      searchesProduct: [],
      search: '',
      searchTablevisibility: false,
      pageNumber: 1,
      lengthProducts: 0,
      docNum: '',
      modal: false,
      preRecordInfo: {},
      array: [],
      errorForm: {
        warehouseName: '',
        isInputError: '',
        warehouseTypeError: ''
      },
      docArr: [],
      allDocTypes: [],
      providerId: '',
      checked: false,
      refFactorNo: '',
      modalConfirm: false,
      modalError: false,
      unMatchProduct: [],
      errorCountText: '',
      checkIsInput: '',
      description: '',
      textUnMatch: '',
      tableNotFound: false,
      tableNotRemain: false,
      incompatibleRemainProducts: [],
      incompatibleSupplyOrderProducts: [],
      incompatibleDispatchProducts: [],
      anbarType: '',
      anbarTypeTaraf: '',
      providerIdSearch: null,
      selectedWarehouseId: null,
      selectedRefWarehouseId: null,
      deliveryDates: [],
      parcelId: '',
      sendRequest: true
    }
  }

  handleChangeSearchable = (selectedOption) => {
    this.setState({selectedOption})
    this.setState({
      providerValue: selectedOption.value
    })
    console.log(`Option selected:`, selectedOption)
  }

  handleDateChangeManual = (date) => {
    this.setState({manualReg: date})
  }

  handleDaterefFactor = (date) => {
    this.setState({refFactor: date})
  }

  preventType = (e) => {
    e.preventDefault()
  }

  sortByKey = (array, key) => {
    return array.sort(function(a, b) {
      var x = a[key]
      var y = b[key]
      return x < y ? -1 : x > y ? 1 : 0
    })
  }

  getPreviewDoc = (data) => {
    return http
      .post(`${WAREHOUSE.WAREHOUSE_DOCUMENT_GET_PREVIEW}`, data, {})
      .then((response) => {
        let test = response.data.object.detailEntities
        for (let i = 0; i < test.length; i++) {
          if (test[i].manufactureDate === null) {
            test[i].manufactureDate = ''
          }
        }
        this.setState(
          {
            preRecordInfo: response.data.object,
            product: this.sortByKey(response.data.object.detailEntities, 'rowNo'),
            manualReg:
              response.data.object.manualRegisterDate == moment() ? undefined : response.data.object.manualRegisterDate,
            refFactor: response.data.object.refFactorDate == moment() ? undefined : response.data.object.refFactorDate,
            isInput: response.data.object.input,
            typeWarehouseId: response.data.object.typeWarehouseId,
            providerId: response.data.object.providerId,
            providerIdSearch: response.data.object.providerId,
            isInternal: response.data.object.internal,
            refWarehouseId: response.data.object.refTypeWarehouseId,
            checked: response.data.object.internal,
            checkIsInput: response.data.object.input,
            description: response.data.object.description,
            abnormal: response.data.object.abnormal,
            otherSellers: response.data.object.otherSellers,
            refType: response.data.object.refType,
            parcelId: response.data.object.parcelId ? response.data.object.parcelId : '',
            init: false
          },
          () => {
            let data = this.state.product
            for (let i = 0; i < data.length; i++) {
              if (data[i]['productUnitTitle'] == 'کیلو گرم' || data[i]['productUnitTitle'] == 'لیتر') {
                data[i]['vahed'] = 'ashar'
              } else {
                data[i]['vahed'] = 'sahih'
              }
            }

            let isInput = this.state.isInput
            var filterWare = this.state.docArr
            http
              .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_DOCUMENT}`, {})
              .then((response) => {
                this.setState({
                  docType: response.data.object
                })
                filterWare = []
                this.state.docType.forEach(function(item) {
                  if (isInput == true) {
                    if (item.in == true) {
                      filterWare.push(item)
                    }
                  } else {
                    if (item.out == true) {
                      filterWare.push(item)
                    }
                  }
                })
                this.setState({
                  docType: filterWare
                })
              })
              .catch((error) => {
                console.log(error)
              })
            const {product} = this.state

            for (let i = 0; i < product.length; i++) {
              let details = {
                id: product[i]['stockProductId'],
                quantity: Number(product[i]['quantity']),
                manufactureDate: this.convertDigit(product[i]['manufactureDate'])
              }
              let detailsArray = []

              detailsArray.push(details)

              this.setState((prevState) => ({
                details: [...prevState.details, details]
              }))
            }
          }
        )
        return response.data.object
      })
      .catch(() => {})
  }

  componentDidMount() {
    // setTimeout(()=>{
    //     let targetAnbar = this.anbarType;
    //     let targetAnbarTaraf = this.anbarTaraf
    //     const anbarType = targetAnbar.options[targetAnbar.selectedIndex].getAttribute('data-anbarType');
    //
    //     const anbarTypeTaraf = targetAnbarTaraf.options[targetAnbarTaraf.selectedIndex].getAttribute('data-anbarType');
    //     this.setState({
    //         anbarType : anbarType === null ? '' : anbarType,
    //         anbarTypeTaraf : anbarTypeTaraf === null ? '' : anbarTypeTaraf
    //     })
    // },5000)
    const {preWarehouseDocId} = this.props.match.params
    this.setState({
      loading: true
    })
    this.getPreviewDoc({docId: preWarehouseDocId})
      .then((res) => {
        let typeWareHouseId = res.typeWarehouseId
        let refWarehouseId = res.refTypeWarehouseId
        let providerId = res.providerId
        this.setState({
          loading: false
        })
        this.loadSelectedProvider(typeWareHouseId, providerId)
        this.getWareHouseList(typeWareHouseId, refWarehouseId)
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  getWareHouseList = (typeWareHouseId, refWarehouseId) => {
    return http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].id
            result[i]['label'] = result[i].name + ' - ' + result[i].typePrimaryName
          }
          this.setState(
            {
              wareHousesname: response.data.object
            },
            () => {
              let findTypeWarehouse = this.state.wareHousesname.find((item) => +item.id === typeWareHouseId)
              if (findTypeWarehouse) {
                this.setState({
                  selectedWarehouseId: findTypeWarehouse
                })
              }
              let findRefTypeWarehouseId = this.state.wareHousesname.find((item) => +item.id === refWarehouseId)
              if (findRefTypeWarehouseId) {
                this.setState({
                  selectedRefWarehouseId: findRefTypeWarehouseId
                })
              }
            }
          )
          return response.data.object
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  loadSelectedProvider = (typeWareHouseId, providerId) => {
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}?typeWarehouseId=${typeWareHouseId}`, {}).then((response) => {
    //     if (response.data.error == null) {
    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] =result[i].providerId +' - '+ result[i].title;
    //         }
    //         this.setState({
    //             providers: response.data.object
    //         }, () => {
    //             if (providerId !== '' || providerId !== null) {
    //                 let findSelectedProviderId = this.state.providers.find(item => +item.providerId === +providerId)
    //                 if (findSelectedProviderId) {
    //                     this.setState({
    //                         providerId: findSelectedProviderId,
    //                         providerIdSearch: findSelectedProviderId,
    //                     })
    //                 }
    //             }
    //         })
    //     }
    //     else{
    //         this.setState({
    //             providers: []
    //         })
    //     }
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });
  }

  getValueProvider = (providerId) => {
    this.setState({
      providerId,
      providerIdSearch: providerId
    })
  }

  getValueProviderSearch = (providerIdSearch) => {
    this.setState({
      providerIdSearch
    })
  }

  submitForm(e) {
    e.preventDefault()
  }

  onChange = (e) => {
    console.log('radio checked', e.target.isInput)
    this.setState({
      isInput: e.target.value
    })
  }

  changeWareHouseId = (selectedWarehouseId) => {
    this.setState({
      selectedWarehouseId,
      typeWarehouseId: selectedWarehouseId ? selectedWarehouseId.id : ''
    })
  }

  changeRefWareHouseId = (selectedRefWarehouseId) => {
    this.setState({
      selectedRefWarehouseId
    })
  }

  changeField(e) {
    const target = e.target
    const value = target.type == 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value,
      id: value
    })

    if (name === 'refWarehouseId') {
      const anbarTypeTaraf = target.options[target.selectedIndex].getAttribute('data-anbarTypeTaraf')

      this.setState({
        anbarTypeTaraf
      })
    }
  }

  onChangeRadio = (e) => {
    console.log('radio checked', e.target.value)
    this.setState({
      valueBarcode: e.target.value
    })
  }

  onchangeSearch = (e) => {
    this.setState({
      search: e.target.value
    })
  }

  showModal = () => {
    this.setState({
      visible: true
    })
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      searchesProduct: [],
      searchTablevisibility: false
    })
  }

  onChangePagination(pageNumber) {
    this.setState({
      pageNumber: pageNumber
    })
    // console.log('Page: ', pageNumber);

    let productName = document.getElementById('productName').value
    let providerIdSearch = this.state.providerIdSearch
    let articleCode = document.getElementById('articleCode').value
    let productCode = document.getElementById('productCode').value

    http
      .get(
        `${
          REPORT_RETAIL.REPORT_RETAIL_PRODUCT
        }?export=false&productName=${productName}&articleId=${articleCode}&productCode=${productCode}&providerId=${providerIdSearch}&typeWarehouseId=${
          this.state.typeWarehouseId
        }&pageSize=7&pageNumber=${pageNumber}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          let data = response.data.object.result
          for (let i = 0; i < data.length; i++) {
            if (data[i]['productUnitTitle'] == 'عدد') {
              data[i]['vahed'] = 'sahih'
            } else {
              data[i]['vahed'] = 'ashar'
            }
          }

          this.setState({
            searchesProduct: response.data.object.result,
            searchTablevisibility: true,
            lengthProducts: response.data.object.countAll
          })
        } else {
          message.error(response.data.description)
        }

        // alert(response.data.object.countAll)
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  searchProduct(e) {
    let productName = document.getElementById('productName').value
    let articleCode = document.getElementById('articleCode').value
    let productCode = document.getElementById('productCode').value
    let providerIdSearch = this.state.providerIdSearch ? this.state.providerIdSearch : ''
    if (!providerIdSearch && productName == '' && articleCode == '' && productCode == '') {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      // if(productCode.length=='13' && !(productCode[0]=='6')){
      //     var extractBarcode=productCode.substring(1,7)
      //     productCode=extractBarcode;
      //     var extractWeight=productCode.substring(7,12)
      // }
      // else{
      //     productCode=productCode;
      // }

      http
        .get(
          `${
            REPORT_RETAIL.REPORT_RETAIL_PRODUCT
          }?export=false&providerId=${providerIdSearch}&productName=${productName}&articleId=${articleCode}&productCode=${productCode}&typeWarehouseId=${
            this.state.typeWarehouseId
          }&pageSize=7&pageNumber=1`,
          {}
        )
        .then((response) => {
          if (response.data.error == null) {
            let data = response.data.object.result
            for (let i = 0; i < data.length; i++) {
              if (data[i]['productUnitTitle'] == 'عدد') {
                data[i]['vahed'] = 'sahih'
              } else if (data[i]['productUnitTitle'] == 'بسته') {
                data[i]['vahed'] = 'sahih'
              } else if (data[i]['productUnitTitle'] == 'شانه') {
                data[i]['vahed'] = 'sahih'
              } else {
                data[i]['vahed'] = 'ashar'
              }
            }

            this.setState({
              searchesProduct: response.data.object.result,
              searchTablevisibility: true,
              lengthProducts: response.data.object.countAll
            })
          } else {
            this.setState({
              searchesProduct: [],
              searchTablevisibility: false
            })
            message.error(response.data.description)
          }
          // alert(response.data)
        })
        .catch((error) => {
          alert('error is' + JSON.stringify(error))
        })
    }
  }

  handleOk = (e) => {
    let {search} = this.state
    let productObject = this.state.searchesProduct[search]
    if (productObject == undefined) {
      message.error('محصول مورد نظر را انتخاب کنید سپس تایید کنید')
    } else {
      this.quantity.focus()
      this.barcode.value = this.barcode.value = productObject['productCode']

      this.setState({
        modal: !this.state.modal,
        searchesProduct: [],
        searchTablevisibility: false
      })

      //
      // let details = {
      //     id: productObject['stockProductId']
      //     ,
      //     quantity: 1
      // };
      // let detailsArray = [];
      // detailsArray.push(details);
      // let findDetails = this.state.details.find(detailsArray => detailsArray.id == details.id);
      // if (!findDetails) {
      //     this.setState((prevState) => ({
      //         details: [...prevState.details, details]
      //     }))
      // }
      // let array = [];
      // array.push(productObject);
      // productObject['quantity'] = 1;
      // let isFound = this.state.product.find(product => product.articleId == productObject.articleId);
      //
      // if (!isFound) {
      //
      //
      //     this.setState((prevState) => ({
      //         product: [...prevState.product, productObject],
      //         fadeTable: 'false'
      //         ,
      //         id: ''
      //         ,
      //         search: ''
      //     }))
      //
      // } else {
      //     var index = this.state.product.findIndex(product => product.articleId == productObject.articleId);
      //     if (index >= 0) {
      //         this.barcode.focus();
      //         this.setState((prevState) => {
      //             const newProduct = this.state.product;
      //             newProduct[index].quantity = Number(newProduct[index].quantity) + Number(productObject['quantity']);
      //             return {
      //                 product: newProduct
      //             }
      //         })
      //     }
      // }
      // this.setState({
      //     modal: !this.state.modal
      // });
      // console.log(e);
      // this.setState({
      //     visible: false,
      //     searchTablevisibility: false,
      //     searchesProduct: []
      // });
    }
  }

  handleCancel = (e) => {
    console.log(e)
    this.setState({
      visible: false,
      searchTablevisibility: false,
      searchesProduct: []
    })

    this.setState({
      modal: !this.state.modal
    })
  }

  optionalFields(e) {
    const target = e.target
    const value = target.value
    const name = target.name
    if (!(value == '')) {
      this.setState({
        [name]: value
      })
    } else {
      this.setState({
        [name]: ''
      })
    }
  }

  barcodeChange(e) {
    const target = e.target
    const value = target.value

    const name = target.name
    const valueRadio = this.state.valueBarcode

    if (
      valueRadio == 'barcodeCount' &&
      e.key == 'Enter' &&
      (document.getElementById('id').value.length == '13' && document.getElementById('id').value[0] != '6')
    ) {
      e.preventDefault()

      //alert('hi')
      document.getElementById('quantity').value = ''

      document.getElementById('quantity').select()
    } else if (valueRadio == 'barcodeCount' && e.key == 'Enter' && document.getElementById('id').value.length == '16') {
      e.preventDefault()
      message.error('لطفا در حالت بارکد کار کنید')
      document.getElementById('id').select()
    } else if (valueRadio == 'barcodeCount' && e.key == 'Enter' && document.getElementById('id').value.length == '18') {
      e.preventDefault()
      message.error('لطفا در حالت بارکد کار کنید')
      document.getElementById('id').select()
    } else if (valueRadio == 'barcodeCount' && e.key == 'Enter' && document.getElementById('id').value.length != '13') {
      e.preventDefault()

      //alert('hi')
      document.getElementById('quantity').value = ''

      document.getElementById('quantity').select()
    } else if (
      valueRadio == 'barcodeCount' &&
      e.key == 'Enter' &&
      (document.getElementById('id').value.length == '13' && document.getElementById('id').value[0] == '6')
    ) {
      e.preventDefault()

      //alert('hi')
      document.getElementById('quantity').value = ''

      document.getElementById('quantity').select()
    }
  }

  changeQuantity(e) {
    const target = e.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }

  createProductObject = (id, quantity, response) => {
    let url = this.state.beepUrl
    let audio = new Audio(url)
    audio.play()
    var decimalDobule = 3

    let details = {
      id: id,
      quantity: quantity,
      manufactureDate: ''
    }
    let {lastEnteredProduct} = this.state
    lastEnteredProduct.count = quantity
    this.setState({
      lastEnteredProduct
    })
    let detailsArray = []
    detailsArray.push(details)
    let findDetails = this.state.details.find((detailsArray) => detailsArray.id == details.id)
    if (!findDetails) {
      this.setState((prevState) => ({
        details: [...prevState.details, details]
      }))
      // alert(JSON.stringify(this.state.details))
    } else {
      findDetails.quantity = (Number(findDetails.quantity) + Number(quantity))
        .toFixed(decimalDobule)
        .replace(/.000/g, '')
    }
    let array = []
    array.unshift(response)

    let isFound = this.state.product.find((product) => product.articleId == response.articleId)

    if (!isFound) {
      this.barcode.focus()
      this.setState((prevState) => ({
        product: [response, ...prevState.product],
        fadeTable: 'false',
        id: ''
      }))

      // this.setState({
      //     product:this.state.product
      // })
    } else {
      var index = this.state.product.findIndex((product) => product.articleId == response.articleId)
      if (index >= 0) {
        this.barcode.focus()
        this.setState((prevState) => {
          const newProduct = this.state.product
          newProduct[index].quantity = (Number(newProduct[index].quantity) + Number(quantity))
            .toFixed(decimalDobule)
            .replace(/.000/g, '')
          return {
            product: newProduct
          }
        })
      }
    }
  }

  addDialogLastProduct = (res) => {
    this.setState(
      {
        sendRequest: false,
        lastEnteredProduct: {
          name: res.data.object.productName,
          barcode: res.data.object.productCode,
          time: jMoment().format('HH:mm'),
          count: '',
          unit: res.data.object.productUnitTitle
        },
        showLastProduct: true,
        addProduct: true,
        removeProduct: false
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              sendRequest: true
            },
            () => {}
          )
        }, 10)
      }
    )
  }

  addProduct() {
    if (this.state.sendRequest) {
      this.setState({
        sendRequest: false
      })
      const valueRadio = this.state.valueBarcode
      let id = document.getElementById('id').value.trim()
      var extractId = ''
      let quantity = document.getElementById('quantity').value

      if (id == '') {
        this.setState({
          addError: 'یک محصول وارد کنید'
        })
      } else if (
        this.state.valueBarcode == 'barcodeCount' &&
        quantity == '' &&
        document.getElementById('id').value.trim().length == '13'
      ) {
        this.setState({
          addError: 'تعداد محصول وارد کنید'
        })
      } else if (
        this.state.valueBarcode == 'barcodeCount' &&
        quantity == '' &&
        document.getElementById('id').value.trim().length == '16'
      ) {
        message.error('لطفا در حالت بارکد کار کنید')
      } else if (
        this.state.valueBarcode == 'barcodeCount' &&
        quantity == '' &&
        document.getElementById('id').value.trim().length == '18'
      ) {
        message.error('لطفا در حالت بارکد کار کنید')
      } else if (
        this.state.valueBarcode == 'barcodeCount' &&
        quantity != '' &&
        document.getElementById('id').value.trim().length == '16'
      ) {
        message.error('لطفا در حالت بارکد کار کنید')
      } else if (
        this.state.valueBarcode == 'barcodeCount' &&
        quantity != '' &&
        document.getElementById('id').value.trim().length == '18'
      ) {
        message.error('لطفا در حالت بارکد کار کنید')
      } else if (this.state.valueBarcode == 'barcodeCount' && quantity.match(/[a-z A-Z]/g)) {
        this.setState({
          addError: 'تعداد محصول باید عددی باشد'
        })
      } else if (this.state.valueBarcode == 'barcodeCount' && quantity.match(/[a-z A-Z آ-ی]/g)) {
        this.setState({
          addError: 'تعداد محصول باید عددی باشد'
        })
      } else if (this.state.valueBarcode == 'barcodeCount' && quantity.match(/[!@#$%^&*()\-+,?":{}=|<>/]/g)) {
        this.setState({
          addError: 'تعداد محصول باید عددی باشد'
        })
      } else {
        // if(id.length=='13' && !(id[0]=='6')){
        //     var extractBarcode=id.substring(1,7)
        //     id=extractBarcode;
        //     alert(id)
        //     var extractWeight=id.substring(7,12)
        // }
        if (id.length == '16') {
          var extractBarcode = id.substring(5, 11)
          var extractWeight = id.substring(11, 16)
          extractId = extractBarcode
        } else if (id.length == '18') {
          var extractBarcode = id.substring(7, 13)
          var extractWeight = id.substring(13, 18)
          extractId = extractBarcode
        } else {
          extractId = id
        }

        http
          .get(`${REPORT_RETAIL.REPORT_RETAIL_GET_PRODUCTBYCODE}?code=${extractId}`, {})
          .then((response) => {
            if (response.data.error == null) {
              var idValue = document.getElementById('id').value.trim()
              // this.setState({
              //     lastEnteredProduct: {
              //         name: response.data.object.productName,
              //         barcode: response.data.object.productCode,
              //         time: jMoment().format('HH:mm'),
              //         count: '',
              //         unit: response.data.object.productUnitTitle
              //     },
              //     showLastProduct: true,
              //     addProduct: true,
              //     removeProduct: false
              // })

              let data = response.data.object
              if (data.productUnitTitle == 'کیلو گرم' || data.productUnitTitle == 'لیتر') {
                data.vahed = 'ashar'
              } else {
                data.vahed = 'sahih'
              }

              this.setState({
                addError: ''
              })

              var productObject = response.data.object
              productObject['manufactureDate'] = ''
              var proId = response.data.object.providerId
              var stateProviderId = this.state.providerId
              // alert(proId)
              // alert(stateProviderId)

              if (data.productUnitTitle == 'کیلو گرم' || data.productUnitTitle == 'لیتر') {
                if (valueRadio == 'barcodeOnly' && idValue.length == '16') {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = idValue
                  var extractWeight = temp.substring(11, 16)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''

                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeOnly' && idValue.length == '18') {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = idValue
                  var extractWeight = temp.substring(13, 18)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''
                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeCount' && idValue.length == '16') {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = idValue
                  var extractWeight = temp.substring(11, 16)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''

                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeCount' && idValue.length == '18') {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = idValue
                  var extractWeight = temp.substring(13, 18)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''

                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeOnly' && (idValue.length != '16' && idValue.length != '18')) {
                  let url = this.state.wrongUrl
                  let audio = new Audio(url)
                  audio.play()
                  message.error('بارکد وارد شده برای یک محصول وزنی است.لطفا تعداد را وارد کنید')
                } else if (
                  valueRadio == 'barcodeCount' &&
                  quantity == '' &&
                  (idValue.length != '16' && idValue.length != '18')
                ) {
                  let url = this.state.wrongUrl
                  let audio = new Audio(url)
                  audio.play()

                  $('#quantity').select()
                  // $('#id').val('')
                  $('#quantity').val('')
                  message.error('بارکد وارد شده برای یک محصول وزنی است.لطفا تعداد را وارد کنید')

                  // productObject['quantity'] = quantity;
                  // this.createProductObject(productObject['stockProductId'],productObject['quantity'],productObject)
                } else if (
                  valueRadio == 'barcodeCount' &&
                  quantity != '' &&
                  (idValue.length != '16' && idValue.length != '18')
                ) {
                  // message.error('بارکد وارد شده برای یک محصول وزنی است.لطفا تعداد را وارد کنید')

                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = quantity
                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeOnly' && (idValue.length == '13' && idValue[0] != '6')) {
                  message.error('بارکد وارد شده برای یک محصول وزنی است.لطفا تعداد را وارد کنید')
                  let url = this.state.wrongUrl
                  let audio = new Audio(url)
                  audio.play()
                } else if (valueRadio == 'barcodeCount' && (idValue.length == '13' && idValue[0] != '6')) {
                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = quantity
                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                }
              } else {
                if (valueRadio == 'barcodeOnly' && idValue.length == '16') {
                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = idValue
                  var extractWeight = temp.substring(11, 16)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''
                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeOnly' && idValue.length == '18') {
                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = idValue
                  var extractWeight = temp.substring(13, 18)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''

                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeCount' && idValue.length == '16') {
                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = idValue
                  var extractWeight = temp.substring(11, 16)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''
                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeCount' && idValue.length == '18') {
                  $('#quantity').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  var temp = idValue
                  var extractWeight = temp.substring(13, 18)
                  productObject['quantity'] = Number(extractWeight / 1000)
                  idValue = ''
                  document.getElementById('quantity').value = ''

                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeOnly' && (idValue.length != '16' && idValue.length != '18')) {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = '1'

                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (
                  valueRadio == 'barcodeCount' &&
                  quantity != '' &&
                  (idValue.length != '16' && idValue.length != '18')
                ) {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = quantity
                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (
                  valueRadio == 'barcodeCount' &&
                  quantity == '' &&
                  (idValue.length != '16' && idValue.length != '18')
                ) {
                  $('#quantity').select()
                  // $('#id').val('')
                  $('#quantity').val('')

                  message.error('تعداد را وارد کنید')
                } else if (valueRadio == 'barcodeOnly' && (idValue.length == '13' && idValue[0] != '6')) {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = '1'

                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                } else if (valueRadio == 'barcodeCount' && (idValue.length == '13' && idValue[0] != '6')) {
                  $('#id').select()
                  $('#id').val('')
                  $('#quantity').val('')

                  productObject['quantity'] = quantity

                  if (stateProviderId != '' && proId == stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else if (!stateProviderId) {
                    this.addDialogLastProduct(response)
                    this.createProductObject(productObject['stockProductId'], productObject['quantity'], productObject)
                  } else {
                    let url = this.state.wrongUrl
                    let audio = new Audio(url)
                    audio.play()
                    $('#id').select()
                    $('#id').val('')
                    $('#quantity').val('')
                    message.error('این کالا مربوط به این تامین کننده نیست')
                  }
                }
              }
            } else {
              // message.error(response.data.description)
              // $('#id').select()
              let url = this.state.wrongUrl
              let audio = new Audio(url)
              audio.play()
              $('#id').select()
              $('#id').val('')
              $('#quantity').val('')
              this.setState({
                sendRequest: true
              })
            }
          })
          .catch((error) => {
            this.setState({
              sendRequest: true
            })
            //alert(JSON.stringify(error))
          })
      }
    }
  }

  delete = (rowId) => {
    const object = {
      id: this.state.product[rowId].stockProductId,
      quantity: this.state.product[rowId].quantity
    }
    var index = this.state.details.findIndex((details) => details.id === object.id)
    this.setState({
      lastEnteredProduct: {
        name: this.state.product[rowId].productName,
        barcode: this.state.product[rowId].productCode,
        time: jMoment().format('HH:mm'),
        count: this.state.product[rowId].quantity,
        unit: this.state.product[rowId].productUnitTitle
      },
      addProduct: false,
      removeProduct: true
    })
    var find = this.state.details.find((details) => details.id === object.id)
    this.state.details.splice(index, 1)
    this.state.product.splice(rowId, 1)

    this.setState(
      {
        product: this.state.product,
        details: this.state.details
      },
      () => {
        if (this.state.product.length === 0) {
          this.setState({
            showLastProduct: false
          })
        }
      }
    )

    this.setState(this.state.product)
    this.setState(this.state.details)
    if (this.state.product.length == '0') {
      this.setState({
        fadeTable: 'true'
      })
    }
  }

  double = (rowId) => {
    let productObject = this.state.searchesProduct[rowId]
    this.quantity.focus()
    this.barcode.value = productObject['productCode']
    this.setState({
      modal: !this.state.modal,
      searchesProduct: [],
      searchTablevisibility: false
    })

    // this.setState({
    //     visible: false,
    //     searchTablevisibility: false,
    //     searchesProduct: []
    // });

    //
    // let details = {
    //     id: productObject['stockProductId']
    //     ,
    //     quantity: 1
    // };

    // let detailsArray = [];
    // detailsArray.push(details);
    // let findDetails = this.state.details.find(detailsArray => detailsArray.id == details.id);
    // if (!findDetails) {
    //     this.setState((prevState) => ({
    //         details: [...prevState.details, details]
    //     }))
    // }
    //
    // let array = [];
    // array.push(productObject);
    // // alert(JSON.stringify(productObject))
    // productObject['quantity'] = 1;
    // let isFound = this.state.product.find(product => product.articleId == productObject.articleId);
    //
    // if (!isFound) {
    //
    //
    //
    //     this.setState((prevState) => ({
    //         product: [...prevState.product, productObject],
    //         fadeTable: 'false'
    //         ,
    //         id: ''
    //     }))
    //
    // } else {
    //     var index = this.state.product.findIndex(product => product.articleId == productObject.articleId);
    //     if (index >= 0) {
    //         this.barcode.focus();
    //         this.setState((prevState) => {
    //             const newProduct = this.state.product;
    //             newProduct[index].quantity = Number(newProduct[index].quantity) + Number(productObject['quantity']);
    //             return {
    //                 product: newProduct
    //             }
    //         })
    //     }
    // }
    // this.setState({
    //     modal: !this.state.modal
    // });
    // this.setState({
    //     visible: false,
    //     searchTablevisibility: false,
    //     searchesProduct: []
    // });
  }

  changeCount = (rowId, value) => {
    let target = rowId.target
    const object = {
      id: this.state.product[rowId].stockProductId,
      quantity: this.state.product[rowId].quantity
    }

    var index = this.state.details.findIndex((details) => details.id === object.id)

    const {details} = this.state

    // alert(value)
    const {product} = this.state
    this.setState((prevState) => {
      const newDetails = details
      const newProduct = product
      newProduct[rowId].quantity = value
      newDetails[index].quantity = value
      return {
        product: newProduct,
        details: newDetails
      }
    })
  }

  epochTo = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)
      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let to = miladiDate + ' ' + '23:59:59'
      let toEpoch = moment.utc(to).valueOf()
      if (n >= 0) {
        return toEpoch - 3.5 * 3600 * 1000
      } else if (n < 0 && concatDate === '0101') {
        return toEpoch - 3.5 * 3600 * 1000
      } else {
        return toEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  epochFrom = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)
      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let from = miladiDate + ' ' + '00:00'
      let fromEpoch = moment.utc(from).valueOf()
      if (n >= 0) {
        return fromEpoch - 3.5 * 3600 * 1000
      } else if (n < 0 && concatDate === '0101') {
        return fromEpoch - 3.5 * 3600 * 1000
      } else {
        return fromEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  setValueRefFactorNumber = (isInput, refType, isInternal) => {
    if (isInternal) return null
    if (!refType) return document.getElementById('refFactorNo').value
    if (refType === 'CUSTOMER' && isInput) return document.getElementById('refFactorNo').value
    if (refType === 'PROVIDER' && isInput) return document.getElementById('refFactorNo').value

    if (refType === 'PROVIDER' && !isInput) return null
    if (refType === 'CUSTOMER' && isInput) return document.getElementById('refFactorNo').value
    if (refType === 'CUSTOMER' && !isInput) return document.getElementById('refFactorNo').value
  }

  getInvoiceNumValue = () => {
    if (this.showInvoiceNumInvoiceDate().show) {
      return document.getElementById('refFactorNo').value
    } else {
      return null
    }
  }

  getInvoiceDateValue = () => {
    if (this.showInvoiceNumInvoiceDate().show) {
      return this.convertDigit(document.getElementById('refFactorDate').value)
    } else {
      return null
    }
  }

  Edit() {
    let {checked, refType} = this.state

    // alert(JSON.stringify(this.state.details))
    // let typeWarehouseId = document.getElementById('wareType').value;
    let typeWarehouseId = this.state.selectedWarehouseId === null ? '' : this.state.selectedWarehouseId.id
    let anbarType = this.state.selectedWarehouseId === null ? '' : this.state.selectedWarehouseId.typePrimaryId
    let anbarTypeTaraf =
      this.state.selectedRefWarehouseId === null ? '' : this.state.selectedRefWarehouseId.typePrimaryId
    let senderName = document.getElementById('senderName').value
    let receiverName = document.getElementById('receiverName').value
    // let providerId = document.getElementById('providerId').value;

    // let refWarehouseId = document.getElementById('refWarehouseId').value;
    let refWarehouseId = this.state.selectedRefWarehouseId === null ? '' : this.state.selectedRefWarehouseId.id
    let isInput = document.getElementById('isInput').value
    let typeDocId = document.getElementById('docType').value
    let manualRegisterDate = this.convertDigit(document.getElementById('manualRegisterDate').value)

    // let refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // let refFactorNo = document.getElementById('refFactorNo').value;

    let description = document.getElementById('description').value

    var boolIsInput = isInput == 'true'

    let refFactorDate = this.getInvoiceDateValue()
    let refFactorNo = this.getInvoiceNumValue()

    // let refFactorDate = null

    // let refFactorNo = this.setValueRefFactorNumber(boolIsInput, refType, this.state.checked)

    // if (checked) {
    //     refFactorDate = null
    // }

    // if (boolIsInput && !checked) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    // if (!boolIsInput && refType === 'CUSTOMER' && !this.state.checked) {

    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    // if (refType === '' && !this.state.checked) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    var providerId = null
    if (!this.state.checked) {
      providerId = this.state.providerId
    }

    var manufactor = false
    var submitForm = false

    let findWithOutManufactor = this.state.details.find((item) => item.manufactureDate === '')
    if (findWithOutManufactor && anbarType === 3 && boolIsInput) {
      submitForm = true
      manufactor = true
      message.error('در سند انبار اصلی وارده تاریخ تولید برای تمامی کالا ها الزامیست')
    } else {
      if (!manufactor) {
      }
    }

    if (description == '') {
      this.setState({
        description: undefined
      })
    } else {
      let dataDoc = {
        description: this.state.description
      }
    }

    if (manualRegisterDate == '') {
      this.setState({
        manualRegisterDate: undefined
      })
    } else {
      let dataDoc = {
        manualRegisterDate: manualRegisterDate
      }
    }

    if (senderName == '') {
      this.setState({
        senderName: undefined
      })
    } else {
      let dataDoc = {
        senderName: senderName
      }
    }

    // if (providerId == '') {

    // } else {
    //     let dataDoc = {
    //         providerId: providerId
    //     }
    // }

    if (refFactorNo == '') {
      this.setState({
        refFactorNo: ''
      })
    } else {
      let dataDoc = {
        refFactorNo: refFactorNo
      }
    }

    if (refFactorDate == '') {
      this.setState({
        refFactorDate: undefined
      })
    } else {
      let dataDoc = {
        refFactorDate: refFactorDate
      }
    }

    var submitForm = false
    var wareNameError = false
    var isinputError = false
    var doctypeError = false
    var refFacNO = false
    var manualRegError = false
    var quantityTableError = false

    $('.ashar').each(function() {
      if ($(this).val() <= '0') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/[a-z A-Z آ-ی]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/[!@#$%^&*()\-+,?":{}=|<>]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        if (!quantityTableError) {
          console.log('sd')
        }
      }
    })

    $('.sahih').each(function() {
      if (
        $(this)
          .val()
          .match(/\-?\d+\.\d+/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
        $('#errorCountText').html('واحد صحیح کالا مقدار اعشاری نمیپذیرد')
      } else if ($(this).val() < '1') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
        $('#errorCountText').html('واحد صحیح کالا مقدار کمتر از یک نمیپذیرد')
      } else if (
        $(this)
          .val()
          .match(/[!@#$%^&*()\-+.,?":{}=|<>]/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if ($(this).val() <= '0') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        if (!quantityTableError) {
          $('#errorCountText').html('')

          console.log('sd')
        }
      }
    })

    let parcelId
    if (refType === 'CUSTOMER' && !this.state.checked) {
      parcelId = this.state.parcelId
    } else {
      parcelId = null
    }

    if (refType === 'CUSTOMER' && !this.state.checked && !parcelId) {
      message.error('شناسه مرسوله الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && boolIsInput && !refFactorNo && !this.state.checked) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && !boolIsInput && !refFactorNo && !this.state.checked) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    if (!this.state.checked && !refType) {
      message.error('نوع طرف الزامی است')
      submitForm = true
    }

    // if (refType === 'CUSTOMER' && !boolIsInput && !refFactorDate && !this.state.checked) {
    //     message.error('تاریخ فاکتور الزامی است')
    //     submitForm = true;
    // }

    // if (!(refFactorNo == '') && refFactorNo.match(/[a-z A-Z]/g) || refFactorNo.match(/[!@#$%^&*()\-+,.?":{}=|<>]/g)) {
    //     message.error('شماره فاکتور باید عدد صحیح باشد');
    //     submitForm = true;
    //     refFacNO = true;
    // } else {
    //     if (!refFacNO) {
    //         {
    //             console.log('sd')
    //         }
    //     }
    // }

    if (typeWarehouseId == '') {
      message.error('انبار را مشخص کنید')
      submitForm = true
      wareNameError = true
      this.setState({
        errorForm: {
          warehouseName: 'انبار را مشخص کنید'
        }
      })
    } else {
      if (!wareNameError) {
        this.setState({
          errorForm: {
            warehouseName: ''
          }
        })
      }
    }

    if (manualRegisterDate == '') {
      message.error('تاریخ دستی سند را مشخص کنید')
      submitForm = true
      manualRegError = true
      this.setState({
        errorForm: {
          warehouseName: 'انبار را مشخص کنید'
        }
      })
    } else {
      if (!manualRegError) {
        this.setState({
          errorForm: {
            warehouseName: ''
          }
        })
      }
    }

    if (isInput == '') {
      message.error('ماهیت را مشخص کنید')

      isinputError = true
      submitForm = true
      this.setState({
        errorForm: {
          isInputError: 'ماهیت را مشخص کنید'
        }
      })
    } else {
      if (!isinputError) {
        this.setState({
          errorForm: {
            isInputError: ''
          }
        })
      }
    }

    if (typeDocId == '') {
      message.error('نوع سند را مشخص کنید')

      doctypeError = true
      submitForm = true
      this.setState({
        errorForm: {
          warehouseTypeError: 'نوع سند را مشخص کنید'
        }
      })
    } else {
      if (!doctypeError) {
        this.setState({
          errorForm: {
            warehouseTypeError: ''
          }
        })
      }
    }

    if (checked) {
      if (refWarehouseId == '' || refWarehouseId == null) {
        submitForm = true
        message.error('انبار طرف را مشخص کنید')
      } else if (refWarehouseId === typeWarehouseId) {
        submitForm = true
        message.error('انبار طرف نباید با انبار یکسان باشد')
      } else {
        this.setState({
          errorDocForm: ''
        })

        const {preWarehouseDocId} = this.props.match.params
        var docData = {
          parcelId,
          refType: !refType || this.state.checked ? null : refType,
          docId: preWarehouseDocId,
          typeWarehouseId: typeWarehouseId,
          isInput: isInput,
          isInternal: this.state.checked,
          abnormal: this.state.abnormal,
          typeDocId: typeDocId,
          details: this.state.details,
          description: description == '' ? undefined : description,
          refWarehouseId: refWarehouseId,
          manualRegisterDate: manualRegisterDate == '' ? undefined : this.epochFrom(manualRegisterDate),
          providerId,
          senderName: senderName == '' ? undefined : senderName,
          receiverName: receiverName == '' ? undefined : receiverName,
          refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
          refFactorNo: !refFactorNo ? null : refFactorNo,
          otherSellers: this.state.otherSellers
        }
      }
    } else {
      this.setState({
        errorDocForm: ''
      })
      const token = sessionStorage.getItem('accessToken')
      const {preWarehouseDocId} = this.props.match.params

      var docData = {
        parcelId,
        refType: !refType || this.state.checked ? null : refType,
        docId: preWarehouseDocId,
        typeWarehouseId: typeWarehouseId,
        isInput: isInput,
        isInternal: this.state.checked,
        abnormal: this.state.abnormal,
        typeDocId: typeDocId,
        details: this.state.details,
        description: description == '' ? undefined : description,
        refWarehouseId: refWarehouseId,
        manualRegisterDate: manualRegisterDate == '' ? undefined : this.epochFrom(manualRegisterDate),
        providerId,
        senderName: senderName == '' ? undefined : senderName,
        receiverName: receiverName == '' ? undefined : receiverName,
        refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
        refFactorNo: !refFactorNo ? null : refFactorNo,
        otherSellers: this.state.otherSellers
      }
    }

    if (!submitForm) {
      if (anbarType === 3 && boolIsInput) {
        message.error('لطفا از انبار واسط استفاده کنید')
      } else if (anbarType === 6 && boolIsInput && !checked && providerId === '' && !this.state.otherSellers) {
        message.error('تامین کننده باید انتخاب شود')
      } else if (anbarType === 3 && boolIsInput && !checked && providerId === '') {
        if (confirm('با توجه به اطلاعات ورودی شما تامین کننده انتخاب نشده است.آیا از ادامه عملیات اطمینان دارید؟')) {
          this.setState({
            modalConfirm: !this.state.modalConfirm,
            incompatibleRemainProducts: [],
            incompatibleSupplyOrderProducts: [],
            incompatibleDispatchProducts: []
          })
        }
      } else if (anbarType === 6 && !boolIsInput && checked && anbarTypeTaraf !== 5) {
        if (confirm('با توجه به اطلاعات ورودی شما انبار طرف باید انبارک باشد.آیا از ادامه عملیات اطمینان دارید؟')) {
          this.setState({
            modalConfirm: !this.state.modalConfirm,
            incompatibleRemainProducts: [],
            incompatibleSupplyOrderProducts: [],
            incompatibleDispatchProducts: []
          })
        }
      } else {
        this.setState({
          modalConfirm: !this.state.modalConfirm,
          incompatibleRemainProducts: [],
          incompatibleSupplyOrderProducts: [],
          incompatibleDispatchProducts: []
        })
      }
    }
  }

  cancelConfirm() {
    this.setState({
      modalConfirm: false
    })
  }

  EditPreRecord() {
    let {refType, isInternal, checked, details} = this.state

    let typeWarehouseId = this.state.selectedWarehouseId === null ? '' : this.state.selectedWarehouseId.id
    let receiverName = document.getElementById('receiverName').value
    let senderName = document.getElementById('senderName').value
    // let refFactorNo = document.getElementById('refFactorNo').value;
    // let providerId = (this.state.providerId === null || this.state.providerId === '') ? '' : this.state.providerId.providerId
    let refWarehouseId = this.state.selectedRefWarehouseId === null ? '' : this.state.selectedRefWarehouseId.id
    let isInput = document.getElementById('isInput').value
    let typeDocId = document.getElementById('docType').value
    let manualRegisterDate = this.convertDigit(document.getElementById('manualRegisterDate').value)
    // let refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    let description = document.getElementById('description').value
    let anbarType = this.state.selectedWarehouseId.typePrimaryId

    var boolIsInput = isInput == 'true'

    let refFactorDate = this.getInvoiceDateValue()
    let refFactorNo = this.getInvoiceNumValue()

    // let refFactorDate = null
    // let refFactorNo = this.setValueRefFactorNumber(boolIsInput, refType, checked)

    // if (checked) {
    //     refFactorDate = null
    // }

    // if (!checked && boolIsInput) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    // if (!boolIsInput && refType === 'CUSTOMER' && !this.state.checked) {

    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    // if (refType === '' && !this.state.checked) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    var providerId = null
    if (!this.state.checked) {
      providerId = this.state.providerId
    }

    if (description == '') {
      this.setState({
        description: undefined
      })
    } else {
      let dataDoc = {
        description: this.state.description
      }
    }

    if (manualRegisterDate == '') {
      this.setState({
        manualRegisterDate: undefined
      })
    } else {
      let dataDoc = {
        manualRegisterDate: manualRegisterDate
      }
    }
    if (receiverName == '') {
      this.setState({
        receiverName: undefined
      })
    } else {
      let dataDoc = {
        receiverName: receiverName
      }
    }

    if (senderName == '') {
      this.setState({
        senderName: undefined
      })
    } else {
      let dataDoc = {
        senderName: senderName
      }
    }

    // if (providerId == '') {

    // } else {
    //     let dataDoc = {
    //         providerId: providerId
    //     }
    // }

    if (refFactorNo == '') {
      this.setState({
        refFactorNo: ''
      })
    } else {
      let dataDoc = {
        refFactorNo: refFactorNo
      }
    }

    if (refFactorDate == '') {
      this.setState({
        refFactorDate: undefined
      })
    } else {
      let dataDoc = {
        refFactorDate: refFactorDate
      }
    }

    var submitForm = false
    var wareNameError = false
    var isinputError = false
    var doctypeError = false
    var refFacNO = false
    var quantityTableError = false

    $('.sahih').each(function() {
      if ($(this).val() < '1') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else if (
        $(this)
          .val()
          .match(/\-?\d+\.\d+/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
        $('#errorCountText').html('واحد صحیح کالا مقدار اعشاری نمیپذیرد')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        if (!quantityTableError) {
          console.log('sd')
        }
      }
    })

    $('.ashar').each(function() {
      if ($(this).val() <= '0') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        if (!quantityTableError) {
          console.log('sd')
        }
      }
    })

    let parcelId
    if (refType === 'CUSTOMER' && !this.state.checked) {
      parcelId = this.state.parcelId
    } else {
      parcelId = null
    }

    if (refType === 'CUSTOMER' && !this.state.checked && !parcelId) {
      message.error('شناسه مرسوله الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && boolIsInput && !refFactorNo) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && !boolIsInput && !refFactorNo && !this.state.checked) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    // if (refType === 'CUSTOMER' && !boolIsInput && !refFactorDate && !this.state.checked) {
    //     message.error('تاریخ فاکتور الزامی است')
    //     submitForm = true;
    // }

    // if (!(refFactorNo == '') && refFactorNo.match(/[a-z A-Z]/g)) {
    //     message.error('شماره فاکتور باید عدد صحیح باشد');
    //     submitForm = true;
    //     refFacNO = true;
    // } else {
    //     if (!refFacNO) {
    //         {
    //             console.log('sd')
    //         }
    //     }
    // }

    if (typeWarehouseId == '') {
      message.error('انبار را مشخص کنید')
      submitForm = true
      wareNameError = true
      this.setState({
        errorForm: {
          warehouseName: 'انبار را مشخص کنید'
        }
      })
    } else {
      if (!wareNameError) {
        this.setState({
          errorForm: {
            warehouseName: ''
          }
        })
      }
    }

    if (isInput == '') {
      message.error('ماهیت را مشخص کنید')

      isinputError = true
      submitForm = true
      this.setState({
        errorForm: {
          isInputError: 'ماهیت را مشخص کنید'
        }
      })
    } else {
      if (!isinputError) {
        this.setState({
          errorForm: {
            isInputError: ''
          }
        })
      }
    }

    if (typeDocId == '') {
      message.error('نوع سند را مشخص کنید')

      doctypeError = true
      submitForm = true
      this.setState({
        errorForm: {
          warehouseTypeError: 'نوع سند را مشخص کنید'
        }
      })
    } else {
      if (!doctypeError) {
        this.setState({
          errorForm: {
            warehouseTypeError: ''
          }
        })
      }
    }

    if (checked) {
      if (refWarehouseId == '' || refWarehouseId == null) {
        submitForm = true
        message.error('انبار طرف را مشخص کنید')
      } else if (refWarehouseId === typeWarehouseId) {
        submitForm = true
        message.error('انبار طرف نباید با انبار یکسان باشد')
      } else {
        this.setState({
          errorDocForm: ''
        })

        const {preWarehouseDocId} = this.props.match.params
        var docData = {
          parcelId,
          refType: !refType || this.state.checked ? null : refType,
          docId: preWarehouseDocId,
          typeWarehouseId: typeWarehouseId,
          isInput: isInput,
          isInternal: this.state.checked,
          abnormal: this.state.abnormal,
          typeDocId: typeDocId,
          details: this.state.details,
          description: description == '' ? undefined : description,
          refWarehouseId: refWarehouseId,
          manualRegisterDate: manualRegisterDate == '' ? undefined : this.epochFrom(manualRegisterDate),
          providerId,
          senderName: senderName == '' ? undefined : senderName,
          receiverName: receiverName == '' ? undefined : receiverName,
          refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
          refFactorNo: !refFactorNo ? null : refFactorNo,
          checkIncompatible: true,
          otherSellers: this.state.otherSellers
        }
      }
    } else {
      this.setState({
        errorDocForm: ''
      })
      const token = sessionStorage.getItem('accessToken')
      const {preWarehouseDocId} = this.props.match.params

      var docData = {
        parcelId,
        refType: !refType || this.state.checked ? null : refType,
        docId: preWarehouseDocId,
        typeWarehouseId: typeWarehouseId,
        isInput: isInput,
        isInternal: this.state.checked,
        abnormal: this.state.abnormal,
        typeDocId: typeDocId,
        details: this.state.details,
        description: description == '' ? undefined : description,
        manualRegisterDate: manualRegisterDate == '' ? undefined : this.epochFrom(manualRegisterDate),
        providerId: providerId == '' ? undefined : providerId,
        senderName: senderName == '' ? undefined : senderName,
        receiverName: receiverName == '' ? undefined : receiverName,
        refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
        refFactorNo: !refFactorNo ? null : refFactorNo,
        checkIncompatible: true,
        otherSellers: this.state.otherSellers
      }
    }

    if (!submitForm) {
      this.setState({
        loading: true
      })
      http
        .post(`${WAREHOUSE.WAREHOUSE_DOCUEMNT_EDIT_PREVIEW}`, docData, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          this.setState({loading: false})
          if (response.data.description != null) {
            message.error(response.data.description)
          } else if (response.data.object.unMatch) {
            this.setState({
              modalError: !this.state.modalError,
              modalConfirm: false,
              unMatchProduct: response.data.object.unMatchProducts,
              tableNotFound: true,
              tableNotRemain: false,
              textUnMatch: 'این اجناس در انبار انتخاب شده وجود ندارد'
            })
          } else if (response.data.object.incompatible) {
            this.setState({
              modalError: !this.state.modalError,
              modalConfirm: false,
              incompatibleRemainProducts: response.data.object.incompatibleRemainProducts,
              incompatibleSupplyOrderProducts: response.data.object.incompatibleSupplyOrderProducts,
              incompatibleDispatchProducts: response.data.object.incompatibleDispatchProducts,
              tableNotFound: false,
              tableNotRemain: true,
              textUnMatch: '',
              deliveryDates: response.data.object.deliveryDates
            })
            if (isInput && !this.state.checked && anbarType === 3) {
              if (this.state.incompatibleSupplyOrderProducts.length > 0) {
                this.setState({
                  showClipboardBtn: true
                })
              } else {
                this.setState({
                  showClipboardBtn: false
                })
              }
            } else if (isInput && !this.state.checked && anbarType === 6) {
              if (this.state.incompatibleSupplyOrderProducts.length > 0) {
                this.setState({
                  showClipboardBtn: true
                })
              } else {
                this.setState({
                  showClipboardBtn: false
                })
              }
            }
          } else {
            let successError = 'پیش سند با شماره ' + response.data.object.preDocId + ' ثبت شد.لطفا صبر کنید '
            message.success(successError, 3000)
            this.setState(
              {
                modalConfirm: false
              },
              () => {
                if (isInput && !this.state.checked && anbarType === 3) {
                  let date = this.convertDigit(document.getElementById('manualRegisterDate').value)
                  localStorage.setItem(
                    'clipText',
                    this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'show')
                  )
                  let providerId = this.state.providerId
                  window.open(
                    `/warehouse/link?showPrintLink=${true}&hasUnmatch=${false}&preRecordId=${
                      response.data.object.preDocId
                    }&providerId=${providerId}&date=${date}`,
                    '_blank'
                  )
                  setTimeout(() => {
                    window.location.assign('/ShowPreRecord/' + this.props.match.params.preWarehouseDocId)
                  }, 3000)
                } else if (isInput && !this.state.checked && anbarType === 6) {
                  let date = this.convertDigit(document.getElementById('manualRegisterDate').value)
                  localStorage.setItem(
                    'clipText',
                    this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'show')
                  )
                  let providerId = this.state.providerId
                  window.open(
                    `/warehouse/link?showPrintLink=${true}&hasUnmatch=${false}&preRecordId=${
                      response.data.object.preDocId
                    }&providerId=${providerId}&date=${date}`,
                    '_blank'
                  )
                  setTimeout(() => {
                    window.location.assign('/ShowPreRecord/' + this.props.match.params.preWarehouseDocId)
                  }, 3000)
                } else {
                  setTimeout(() => {
                    window.location.assign('/ShowPreRecord/' + this.props.match.params.preWarehouseDocId)
                  }, 3000)
                }
              }
            )
          }
        })
        .catch((error) => {
          this.setState({loading: false})
        })
    }
  }

  copyClipBoard = (unmatch, error) => {
    let str = ''
    let title =
      ' ردیف ' +
      ' | ' +
      ' سفارش ' +
      ' | ' +
      '  ورود ' +
      ' | ' +
      '       کد کالا          ' +
      ' | ' +
      ' نام کالا ' +
      '\n'
    let dashe = '----------------------------------------------------------------------------------------' + '\n'
    let concat = title + dashe
    for (let i = 0; i < unmatch.length; i++) {
      let barcodeSpace = unmatch[i].barCode
      if (barcodeSpace.length < 13) {
        barcodeSpace = barcodeSpace.padStart(15)
      }
      str +=
        i +
        1 +
        '         |     ' +
        unmatch[i].remainQuantity +
        '        |    ' +
        unmatch[i].requestedQuantity +
        '     |  ' +
        barcodeSpace +
        '  | ' +
        unmatch[i].title +
        '\n'
      // str += 'تعداد سفارش : ' + unmatch[i].remainQuantity + ' ~ ' + ' تعداد ورود :‌ ' + unmatch[i].requestedQuantity + ' ~ ' + ' بارکد محصول‌ :  ' + unmatch[i].barCode + ' ~ ' + ' کد محصول : ' + unmatch[i].articleId + ' ~ ' + ' نام کالا :‌ ' + unmatch[i].title + '\n'
    }
    if (error === 'show') {
      message.success('در clipboard ذخیره شد')
    }

    return title + dashe + str
  }
  epochFrom1 = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }
  epochTo1 = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    if (n >= 0) {
      return toEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return toEpoch - 3.5 * 3600 * 1000
    } else {
      return toEpoch - 3.5 * 3600 * 1000
    }
  }

  cancelError() {
    this.setState({
      modalError: false
    })
  }

  EditFinalyPreRecord() {
    let {refType, isInternal, checked, details} = this.state

    let typeWarehouseId = this.state.selectedWarehouseId === null ? '' : this.state.selectedWarehouseId.id
    let refWarehouseId = this.state.selectedRefWarehouseId === null ? '' : this.state.selectedRefWarehouseId.id
    let receiverName = document.getElementById('receiverName').value
    let senderName = document.getElementById('senderName').value

    // let providerId = (this.state.providerId === null || this.state.providerId === '') ? '' : this.state.providerId.providerId
    // let refFactorNo = document.getElementById('refFactorNo').value;
    let isInput = document.getElementById('isInput').value
    let typeDocId = document.getElementById('docType').value
    let manualRegisterDate = this.convertDigit(document.getElementById('manualRegisterDate').value)
    // let refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    let description = document.getElementById('description').value
    let anbarType = this.state.selectedWarehouseId.typePrimaryId

    var boolIsInput = isInput == 'true'
    let refFactorDate = this.getInvoiceDateValue()
    let refFactorNo = this.getInvoiceNumValue()
    // let refFactorDate = null
    // let refFactorNo = this.setValueRefFactorNumber(boolIsInput, refType, this.state.checked)

    // if (checked) {
    //     refFactorDate = null
    // }

    // if (!checked && boolIsInput) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    // if (!boolIsInput && refType === 'CUSTOMER'  && !this.state.checked) {

    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    // if (refType === '' && !this.state.checked) {
    //     refFactorDate = this.convertDigit(document.getElementById('refFactorDate').value);
    // }

    var providerId = null
    if (!this.state.checked) {
      providerId = this.state.providerId
    }

    if (description == '') {
      this.setState({
        description: undefined
      })
    } else {
      let dataDoc = {
        description: this.state.description
      }
    }

    if (manualRegisterDate == '') {
      this.setState({
        manualRegisterDate: undefined
      })
    } else {
      let dataDoc = {
        manualRegisterDate: manualRegisterDate
      }
    }

    if (senderName == '') {
      this.setState({
        senderName: undefined
      })
    } else {
      let dataDoc = {
        senderName: senderName
      }
    }

    // if (providerId == '') {
    //     this.setState({
    //         providerId: undefined
    //     })
    // } else {
    //     let dataDoc = {
    //         providerId: senderName
    //     }
    // }

    if (refFactorNo == '') {
      this.setState({
        refFactorNo: ''
      })
    } else {
      let dataDoc = {
        refFactorNo: refFactorNo
      }
    }

    if (refFactorDate == '') {
      this.setState({
        refFactorDate: undefined
      })
    } else {
      let dataDoc = {
        refFactorDate: refFactorDate
      }
    }

    var submitForm = false
    var wareNameError = false
    var isinputError = false
    var doctypeError = false
    var refFacNO = false
    var quantityTableError = false

    $('.ashar').each(function() {
      if ($(this).val() <= '0') {
        submitForm = true
        // alert('hi')
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        if (!quantityTableError) {
          console.log('sd')
        }
      }
    })

    $('.sahih').each(function() {
      if (
        $(this)
          .val()
          .match(/\-?\d+\.\d+/g)
      ) {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
        $('#errorCountText').html('واحد صحیح کالا مقدار اعشاری نمیپذیرد')
      } else if ($(this).val() < '1') {
        submitForm = true
        quantityTableError = true
        $(this).css('borderColor', '#f2682e')
        $(this).css('box-shadow', '0 0 0 0.2rem #fbd1c0')
        $('#errorCountText').html('واحد صحیح کالا مقدار کمتر از یک نمیپذیرد')
      } else {
        $(this).css('borderColor', '#65e251')
        $(this).css('box-shadow', '0 0 0 0.2rem #cfedcb')
        if (!quantityTableError) {
          $('#errorCountText').html('')

          console.log('sd')
        }
      }
    })

    let parcelId
    if (refType === 'CUSTOMER' && !this.state.checked) {
      parcelId = this.state.parcelId
    } else {
      parcelId = null
    }

    if (refType === 'CUSTOMER' && !this.state.checked && !parcelId) {
      message.error('شناسه مرسوله الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && boolIsInput && !refFactorNo) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    if (refType === 'CUSTOMER' && !boolIsInput && !refFactorNo && !this.state.checked) {
      message.error('شماره فاکتور الزامی است')
      submitForm = true
    }

    // if (refType === 'CUSTOMER' && !boolIsInput && !refFactorDate && !this.state.checked) {
    //     message.error('تاریخ فاکتور الزامی است')
    //     submitForm = true;
    // }

    // if (!(refFactorNo == '') && refFactorNo.match(/[a-z A-Z]/g)) {
    //     message.error('شماره فاکتور باید عدد صحیح باشد');
    //     submitForm = true;
    //     refFacNO = true;
    // } else {
    //     if (!refFacNO) {
    //         {
    //             console.log('sd')
    //         }
    //     }
    // }

    if (typeWarehouseId == '') {
      message.error('انبار را مشخص کنید')
      submitForm = true
      wareNameError = true
      this.setState({
        errorForm: {
          warehouseName: 'انبار را مشخص کنید'
        }
      })
    } else {
      if (!wareNameError) {
        this.setState({
          errorForm: {
            warehouseName: ''
          }
        })
      }
    }

    if (isInput == '') {
      message.error('ماهیت را مشخص کنید')

      isinputError = true
      submitForm = true
      this.setState({
        errorForm: {
          isInputError: 'ماهیت را مشخص کنید'
        }
      })
    } else {
      if (!isinputError) {
        this.setState({
          errorForm: {
            isInputError: ''
          }
        })
      }
    }

    if (typeDocId == '') {
      message.error('نوع سند را مشخص کنید')

      var doctypeError = true
      this.setState({
        errorForm: {
          warehouseTypeError: 'نوع سند را مشخص کنید'
        }
      })
    } else {
      if (!doctypeError) {
        this.setState({
          errorForm: {
            warehouseTypeError: ''
          }
        })
      }
    }

    if (checked) {
      if (refWarehouseId == '') {
        submitForm = true
        message.error('انبار طرف را مشخص کنید')
      } else if (refWarehouseId === typeWarehouseId) {
        submitForm = true
        message.error('انبار طرف نباید با انبار یکسان باشد')
      } else {
        this.setState({
          errorDocForm: ''
        })

        const {preWarehouseDocId} = this.props.match.params
        var docData = {
          parcelId,
          refType: !refType || this.state.checked ? null : refType,
          docId: preWarehouseDocId,
          typeWarehouseId: typeWarehouseId,
          isInput: isInput,
          isInternal: this.state.checked,
          abnormal: this.state.abnormal,
          typeDocId: typeDocId,
          details: this.state.details,
          description: description == '' ? undefined : description,
          refWarehouseId: refWarehouseId,
          manualRegisterDate: manualRegisterDate == '' ? undefined : this.epochFrom(manualRegisterDate),
          providerId,
          senderName: senderName == '' ? undefined : senderName,
          receiverName: receiverName == '' ? undefined : receiverName,
          refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
          refFactorNo: !refFactorNo ? null : refFactorNo,
          checkIncompatible: false,
          otherSellers: this.state.otherSellers
        }
      }
    } else {
      this.setState({
        errorDocForm: ''
      })
      const token = sessionStorage.getItem('accessToken')
      const {preWarehouseDocId} = this.props.match.params

      var docData = {
        parcelId,
        refType: !refType || this.state.checked ? null : refType,
        docId: preWarehouseDocId,
        typeWarehouseId: typeWarehouseId,
        isInput: isInput,
        isInternal: this.state.checked,
        abnormal: this.state.abnormal,
        typeDocId: typeDocId,
        details: this.state.details,
        description: description == '' ? undefined : description,
        manualRegisterDate: manualRegisterDate == '' ? undefined : this.epochFrom(manualRegisterDate),
        providerId,
        senderName: senderName == '' ? undefined : senderName,
        receiverName: receiverName == '' ? undefined : receiverName,
        refFactorDate: !refFactorDate ? undefined : this.epochFrom(refFactorDate),
        refFactorNo: !refFactorNo ? null : refFactorNo,
        checkIncompatible: false,
        otherSellers: this.state.otherSellers
      }
    }
    if (!submitForm) {
      this.setState({
        loading: true
      })
      http
        .post(`${WAREHOUSE.WAREHOUSE_DOCUEMNT_EDIT_PREVIEW}`, docData, {})
        .then((response) => {
          this.setState({
            loading: false
          })
          if (response.data.description !== null) {
            message.error(response.data.description)
          } else {
            let successError = 'پیش سند با شماره ' + response.data.object.preDocId + ' ثبت شد.لطفا صبر کنید '
            message.success(successError, 3000)
            this.setState(
              {
                modalConfirm: false,
                modalError: false
              },
              () => {
                if (isInput && !this.state.checked && anbarType === 3) {
                  let date = this.convertDigit(document.getElementById('manualRegisterDate').value)
                  localStorage.setItem(
                    'clipText',
                    this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'show')
                  )
                  let providerId = this.state.providerId
                  window.open(
                    `/warehouse/link?showPrintLink=${true}&hasUnmatch=${true}&preRecordId=${
                      response.data.object.preDocId
                    }&providerId=${providerId}&date=${date}&deliveryDates=${this.state.deliveryDates}`,
                    '_blank'
                  )
                  setTimeout(() => {
                    window.location.assign('/ShowPreRecord/' + this.props.match.params.preWarehouseDocId)
                  }, 3000)
                } else if (isInput && !this.state.checked && anbarType === 6) {
                  let date = this.convertDigit(document.getElementById('manualRegisterDate').value)
                  localStorage.setItem(
                    'clipText',
                    this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'show')
                  )
                  let providerId = this.state.providerId
                  window.open(
                    `/warehouse/link?showPrintLink=${true}&hasUnmatch=${true}&preRecordId=${
                      response.data.object.preDocId
                    }&providerId=${providerId}&date=${date}&deliveryDates=${this.state.deliveryDates}`,
                    '_blank'
                  )
                  setTimeout(() => {
                    window.location.assign('/ShowPreRecord/' + this.props.match.params.preWarehouseDocId)
                  }, 3000)
                } else {
                  setTimeout(() => {
                    window.location.assign('/ShowPreRecord/' + this.props.match.params.preWarehouseDocId)
                  }, 3000)
                }
              }
            )

            // this.setState({
            //     modalConfirm: false
            // })
            // setTimeout(() => {
            //     window.location.assign('/ShowPreRecord/'+this.props.match.params.preWarehouseDocId)
            // }, 3000);
          }
        })
        .catch((error) => {
          this.setState({
            loading: false
          })
        })
    }
  }

  toggleChecked = () => {
    this.setState({checked: !this.state.checked, refType: ''})
  }

  manualRegisterDate(props) {
    return <input className="form-control" {...props} />
  }

  refFactorDate(props) {
    return <input className="form-control" {...props} />
  }

  onChangeIsInput() {
    var isInput = document.getElementById('isInput').value
    if (isInput == 'true') {
      var boolInput = true
      this.setState({
        checkIsInput: true
      })
    } else if (isInput == 'false') {
      var boolInput = false
      this.setState({
        checkIsInput: false
      })
    }
    var filterWare = this.state.docArr

    http
      .get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_DOCUMENT}`, {})
      .then((response) => {
        if (response.data.errror == null) {
          this.setState({
            allDocTypes: response.data.object
          })

          filterWare = []
          this.state.allDocTypes.forEach(function(item) {
            if (boolInput == true) {
              if (item.in == true) {
                filterWare.push(item)
              }
            } else {
              if (item.out == true) {
                filterWare.push(item)
              }
            }
          })
          this.setState({
            docType: filterWare
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  changeManufactorDate = (rowId, value) => {
    let target = rowId.target
    const object = {
      id: this.state.product[rowId].stockProductId,
      quantity: this.state.product[rowId].quantity,
      manufactureDate: ''
    }
    var index = this.state.details.findIndex((details) => details.id === object.id)

    const {details} = this.state
    const {product} = this.state
    this.setState((prevState) => {
      const newDetails = details
      const newProduct = product
      newProduct[rowId].manufactureDate = value
      newDetails[index].manufactureDate = value
      return {
        product: newProduct,
        details: newDetails
      }
    })
  }

  setNowDateProduct = (rowId) => {
    let date = this.convertDigit(jMoment().format('jYYYY/jMM/jDD'))

    const object = {
      id: this.state.product[rowId].stockProductId,
      quantity: this.state.product[rowId].quantity
    }
    let index = this.state.details.findIndex((details) => details.id === object.id)
    const {details} = this.state
    const {product} = this.state
    this.setState((prevState) => {
      const newDetails = details
      const newProduct = product
      newProduct[rowId].manufactureDate = date
      newDetails[index].manufactureDate = date
      return {
        product: newProduct,
        details: newDetails
      }
    })
    // alert(jMoment().format('jYYYY/jM/jD'))
  }

  shortKeyManufactorDate = (rowId, e) => {
    // alert(rowId)
    if (e.key === 'f' || e.key === 'F') {
      let date = this.convertDigit(jMoment().format('jYYYY/jMM/jDD'))

      const object = {
        id: this.state.product[rowId].stockProductId,
        quantity: this.state.product[rowId].quantity
      }
      let index = this.state.details.findIndex((details) => details.id === object.id)
      const {details} = this.state
      const {product} = this.state
      this.setState((prevState) => {
        const newDetails = details
        const newProduct = product
        newProduct[rowId].manufactureDate = date
        newDetails[index].manufactureDate = date
        return {
          product: newProduct,
          details: newDetails
        }
      })
    } else {
      // message.error('برای تاریخ امروز دکمه f زده شود')
    }
    // e.key == 'Enter'
  }
  openModal = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  showInvoiceNumInvoiceDate = () => {
    let show = false
    let requiredInvoiceNum = false
    let requiredInvoiceDate = false
    if (!this.state.refType) {
      show = false
    }
    if (this.state.checked && this.state.selectedWarehouseId && this.state.selectedWarehouseId.typePrimaryId == 5) {
      show = true
    } else if (!this.state.checked) {
      show = true
    }

    if (this.state.checkIsInput && this.state.refType === 'CUSTOMER') {
      requiredInvoiceNum = true
    } else if (!this.state.checkIsInput && this.state.refType === 'PROVIDER') {
      show = false
    } else if (!this.state.checkIsInput && this.state.refType === 'CUSTOMER') {
      requiredInvoiceNum = true
    }

    return {
      show,
      requiredInvoiceDate,
      requiredInvoiceNum
    }
  }

  render() {
    const {wareHousesname, preRecordInfo, product} = this.state
    const statusAnbarTaraf = this.state.checked == true ? false : true
    const barcodeStatus = this.state.valueBarcode == 'barcodeOnly' ? true : false
    const style = product.length == '0' ? 'tableProductWarehouse hide' : 'tableProductWarehouse'
    const tableVisibile = this.state.searchTablevisibility ? 'block' : 'hide'
    const {pageNumber} = this.state

    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{`ویرایش پیش سند شماره :‌ ${this.props.match.params.preWarehouseDocId}`}</title>
        </Helmet>
        {/*<AdminMenu/>*/}
        {!this.state.init ? (
          <div className="container-fluid">
            <Loader show={this.state.loading} />

            <ul className="breadcrumb">
              <li>
                <Link to={'/search'}>به روزرسان</Link>
              </li>
              <li>انبار</li>
              <li>ویرایش پیش سند</li>
            </ul>
            <form onSubmit={this.submitForm.bind(this)} noValidate={true}>
              <div className="container-fluid my-2 p-2 bg-white">
                <div className="card">
                  <div className="card-header">
                    <h5 className="mb-0 text-link">
                      <a
                        href={`/ShowPreRecord/${this.props.match.params.preWarehouseDocId}`}
                        target="_blank"
                        className="font-weight-bold mb-0"
                      >
                        {'شماره پیش سند : ' + this.props.match.params.preWarehouseDocId}
                      </a>
                    </h5>
                  </div>
                  <div className="card-body p-3">
                    <div className="row">
                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <label htmlFor="wareType">
                          انبار
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          value={this.state.selectedWarehouseId}
                          onChange={this.changeWareHouseId}
                          options={this.state.wareHousesname}
                          placeholder="------"
                        />
                      </div>
                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <label htmlFor="ماهیت">
                          ماهیت
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className="custom-select"
                          id="isInput"
                          onChange={this.onChangeIsInput.bind(this)}
                          name="isInput"
                          tabIndex="2"
                        >
                          <option
                            value={true}
                            disabled={this.state.checked ? true : false}
                            selected={preRecordInfo.input ? true : false}
                          >
                            وارده
                          </option>
                          <option value={false} selected={!preRecordInfo.input ? true : false}>
                            صادره
                          </option>
                        </select>
                      </div>

                      {!this.state.checked && (
                        <div className="col-12 col-md-4 my-2 col-lg-2">
                          <label>
                            نوع طرف
                            {!this.state.checked && <span className="text-danger">*</span>}
                          </label>
                          <select
                            className="custom-select"
                            onChange={this.changeField.bind(this)}
                            name="refType"
                            id="refType"
                          >
                            <option value="">-----</option>
                            <option selected={this.state.refType === 'CUSTOMER' ? true : false} value={'CUSTOMER'}>
                              مشتری
                            </option>
                            <option selected={this.state.refType === 'PROVIDER' ? true : false} value={'PROVIDER'}>
                              فروشنده
                            </option>
                          </select>
                        </div>
                      )}

                      {!this.state.checked && this.state.refType === 'CUSTOMER' && (
                        <div className="col-12 col-md-4 my-2 col-lg-2">
                          <ParcelSearch
                            label="شناسه مرسوله"
                            required
                            setParcel={(parcelId) => this.setState({parcelId})}
                            value={this.state.parcelId}
                          />
                          {/* <label>شناسه مرسوله
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <input type="number" defaultValue={this.state.parcelId} onChange={this.changeField.bind(this)}
                                                name="parcelId" className="form-control"/> */}
                        </div>
                      )}

                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <label htmlFor="docType">
                          نوع سند
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          id="docType"
                          name="typeDocId"
                          tabIndex="3"
                          className="custom-select"
                          onChange={this.changeField.bind(this)}
                        >
                          <option value="">نوع سند را مشخص کنید</option>
                          {this.state.docType.map((docs, index) => (
                            <option
                              key={index}
                              value={docs.id}
                              selected={docs.id == preRecordInfo.typeDocId ? true : false}
                            >
                              {docs.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                        <label className="hiddenLabel">sd</label>
                        <Checkbox
                          className="form-check"
                          name="isInternal"
                          tabIndex="4"
                          id="isInternal"
                          disabled={this.state.checkIsInput ? true : false}
                          checked={this.state.checked}
                          onChange={this.toggleChecked}
                        >
                          سند بین انبار
                        </Checkbox>
                      </div>
                      <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                        <label className="hiddenLabel">sd</label>
                        <Checkbox
                          name="abnormal"
                          tabIndex="4"
                          checked={this.state.abnormal}
                          onChange={this.changeField.bind(this)}
                        >
                          سند اصلاحی
                        </Checkbox>
                      </div>
                      <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                        <label className="hiddenLabel">sd</label>
                        <Checkbox
                          name="otherSellers"
                          tabIndex="4"
                          checked={this.state.otherSellers}
                          onChange={this.changeField.bind(this)}
                        >
                          خرید متفرقه
                        </Checkbox>
                      </div>
                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <label>تحویل دهنده</label>
                        <input
                          type="text"
                          onChange={this.optionalFields.bind(this)}
                          tabIndex="5"
                          name="senderName"
                          id="senderName"
                          className="form-control"
                          defaultValue={preRecordInfo.senderName}
                        />
                      </div>
                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <label>تحویل گیرنده</label>
                        <input
                          type="text"
                          onChange={this.optionalFields.bind(this)}
                          tabIndex="6"
                          name="receiverName"
                          id="receiverName"
                          className="form-control"
                          defaultValue={preRecordInfo.receiverName}
                        />
                      </div>
                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <label>تاریخ دستی سند </label>
                        <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                          <DatePicker
                            okLabel="تأیید"
                            autoOk={true}
                            leftArrowIcon={<Icon type="left" />}
                            rightArrowIcon={<Icon type="right" />}
                            cancelLabel="لغو"
                            labelFunc={(manualRegVal) =>
                              manualRegVal != null ? manualRegVal.format('jYYYY/jMM/jDD') : ''
                            }
                            onKeyPress={this.preventType}
                            value={this.state.manualReg}
                            onChange={this.handleDateChangeManual}
                            TextFieldComponent={this.manualRegisterDate}
                            tabIndex="7"
                            id="manualRegisterDate"
                            disabled={this.state.typeWarehouseId == '' ? true : false}
                            name="manualRegisterDate"
                            readOnly
                          />
                        </MuiPickersUtilsProvider>
                      </div>

                      {!this.state.checked && (
                        <div className="col-12 col-md-4 my-2 col-lg-2">
                          <AutoComplete
                            label="طرف - تامین کننده"
                            api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                            textField="title"
                            valueField="providerId"
                            id="provider"
                            extraFilter={{typeWarehouseId: this.state.typeWarehouseId, id: this.state.providerId}}
                            disabled={this.state.refType === 'CUSTOMER' ? true : false}
                            value={this.state.providerId}
                            setValue={(providerId) => this.setState({providerId, providerIdSearch: providerId})}
                          />
                        </div>
                      )}

                      <div className="col-12 col-md-4 my-2 col-lg-2">
                        <label>
                          انبار طرف
                          {this.state.checked ? <span className="text-danger">*</span> : null}
                        </label>
                        <Select
                          isDisabled={!this.state.checked}
                          value={this.state.selectedRefWarehouseId}
                          onChange={this.changeRefWareHouseId}
                          options={this.state.wareHousesname}
                          isClearable
                          placeholder="------"
                        />
                      </div>

                      {this.showInvoiceNumInvoiceDate().show && (
                        <div className="col-12 col-md-4 my-2 col-lg-2">
                          <label>
                            شماره فاکتور
                            {this.showInvoiceNumInvoiceDate().requiredInvoiceNum && (
                              <span className="text-danger">*</span>
                            )}
                          </label>
                          <input
                            type="text"
                            onChange={this.optionalFields.bind(this)}
                            tabIndex="10"
                            name="refFactorNo"
                            id="refFactorNo"
                            className="form-control"
                            defaultValue={preRecordInfo.refFactorNo}
                          />
                        </div>
                      )}

                      {this.showInvoiceNumInvoiceDate().show && (
                        <div className="col-12 col-md-4 my-2 col-lg-2">
                          <label>
                            تاریخ فاکتور طرف
                            {this.showInvoiceNumInvoiceDate().requiredInvoiceDate && (
                              <span className="text-danger">*</span>
                            )}
                          </label>
                          <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                            <DatePicker
                              okLabel="تأیید"
                              autoOk={true}
                              leftArrowIcon={<Icon type="left" />}
                              rightArrowIcon={<Icon type="right" />}
                              cancelLabel="لغو"
                              labelFunc={(selectedDate) =>
                                selectedDate != null ? selectedDate.format('jYYYY/jMM/jDD') : ''
                              }
                              onKeyPress={this.preventType}
                              onChange={this.handleDaterefFactor}
                              TextFieldComponent={this.refFactorDate}
                              value={this.state.refFactor}
                              id="refFactorDate"
                              tabIndex="11"
                              name="refFactorDate"
                              readOnly
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      )}

                      {/* <div className='col-12 col-md-4 my-2 col-lg-2'>
                                            <label>شماره فاکتور</label>
                                            <input type="text" onChange={this.optionalFields.bind(this)} tabIndex='10'
                                                name="refFactorNo" id='refFactorNo' className="form-control"
                                                defaultValue={preRecordInfo.refFactorNo}/>
                                        </div> */}

                      {/* {!this.state.checkIsInput && (!this.state.refType || this.state.refType === 'CUSTOMER') && !this.state.checked &&
                                            <div className='col-12 col-md-4 my-2 col-lg-2'>
                                                <label>شماره فاکتور
                                                    {this.state.refType === 'CUSTOMER' && 
                                                        <span className="text-danger">*</span>
                                                    }
                                                </label>
                                                <input type="text" onChange={this.optionalFields.bind(this)} tabIndex='10'
                                                    name="refFactorNo" id='refFactorNo' className="form-control"
                                                defaultValue={preRecordInfo.refFactorNo}/>
                                            </div>                        

                                        } */}

                      {/* {this.state.checkIsInput && (!this.state.refType || this.state.refType === 'CUSTOMER' || this.state.refType === 'PROVIDER') && !this.state.checked &&
                                            <div className='col-12 col-md-4 my-2 col-lg-2'>
                                                <label>تاریخ فاکتور طرف
                                                 
                                                </label>
                                                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                                                    <DatePicker
                                                        okLabel="تأیید"
                                                        autoOk={true}
                                                        leftArrowIcon={<Icon type="left"/>}
                                                        rightArrowIcon={<Icon type="right"/>}
                                                        cancelLabel="لغو"
                                                        labelFunc={selectedDate =>
                                                            selectedDate != null ? selectedDate.format('jYYYY/jMM/jDD') : ''
                                                        }
                                                        onKeyPress={this.preventType}
                                                        onChange={this.handleDaterefFactor}
                                                        TextFieldComponent={this.refFactorDate}
                                                        value={this.state.refFactor}

                                                        id="refFactorDate"
                                                        tabIndex='11'
                                                        name='refFactorDate'
                                                        readOnly
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                        } */}

                      <div className="col-12 my-2">
                        <div className="w-100">
                          <lable>توضیحات</lable>
                          <input
                            type="text"
                            className="form-control mt-1"
                            style={{height: '40px'}}
                            defaultValue={preRecordInfo.description}
                            id="description"
                            name="description"
                            onChange={this.optionalFields.bind(this)}
                            tabIndex="12"
                          />
                        </div>
                      </div>
                    </div>
                    <hr className="my-3" />
                    <div className="row">
                      <div className="col-12 col-md-8 col-lg-9">
                        <div className="row">
                          <div className="col-12 col-md-auto d-flex flex-row justify-content-start align-item-center align-content-center">
                            <RadioGroup
                              className="text-left d-flex flex-row pt-4 pb-0"
                              disabled={this.state.typeWarehouseId == '' ? true : false}
                              onChange={this.onChangeRadio}
                              value={this.state.valueBarcode}
                            >
                              <Radio value="barcodeOnly">بارکد</Radio>
                              <Radio value="barcodeCount">بارکد و تعداد</Radio>
                            </RadioGroup>
                          </div>
                          <div className="col-12 col-md-auto text-left">
                            <label>بارکد</label>
                            <input
                              type="text"
                              disabled={this.state.typeWarehouseId == '' ? true : false}
                              autoComplete="off"
                              id="id"
                              ref={(node) => (this.barcode = node)}
                              maxLength="18"
                              tabIndex="14"
                              className="form-control"
                              onClick={() => this.barcode.select()}
                              onKeyPress={this.barcodeChange.bind(this)}
                              name="code"
                            />
                          </div>
                          <div className="col-12 col-md-auto text-left">
                            <label>تعداد</label>
                            <input
                              type="text"
                              id="quantity"
                              ref={(node, event) => (this.quantity = node)}
                              className="form-control"
                              name="quantity"
                              onClick={() => this.quantity.select()}
                              onChange={this.changeQuantity.bind(this)}
                              tabIndex="15"
                              disabled={barcodeStatus || this.state.typeWarehouseId == '' ? true : false}
                            />
                          </div>
                          <div className="col-12 col-md-auto d-flex flex-column align-content-end justify-content-end">
                            <button
                              className="my-0 form-control btn btn-primary btn-sm"
                              disabled={this.state.typeWarehouseId == '' ? true : false}
                              onClick={this.addProduct.bind(this)}
                              size="sm"
                            >
                              افزودن به لیست
                            </button>
                          </div>
                          <div className="col-12 col-md-auto d-flex flex-column align-content-end justify-content-end">
                            <button
                              className="my-0 form-control btn btn-warning btn-sm"
                              disabled={barcodeStatus || this.state.typeWarehouseId == '' ? true : false}
                              onClick={this.openModal}
                              size="sm"
                            >
                              جست و جوی کالا
                            </button>
                          </div>
                          <div className="col-auto d-flex flex-column align-item-end align-content-end justify-content-end">
                            <p className="errorText mb-0">{this.state.addError}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4  col-lg-3">
                        {this.state.showLastProduct && (
                          <div className={this.state.addProduct ? 'alert alert-success' : 'alert alert-danger'}>
                            <strong>
                              {!this.state.addProduct ? 'مشخصات آخرین کالای حذف شده' : 'مشخصات آخرین کالای وارد شده'}
                            </strong>
                            <hr />
                            <p className="mb-0">{'بارکد ‌: ' + this.state.lastEnteredProduct.barcode}</p>
                            <p className="mb-0">{'نام : ' + this.state.lastEnteredProduct.name}</p>
                            <p className="mb-0">
                              {'مقدار : ' +
                                this.state.lastEnteredProduct.count +
                                ' ' +
                                this.state.lastEnteredProduct.unit}
                            </p>
                            <p className="mb-0">{'ساعت : ' + this.state.lastEnteredProduct.time}</p>
                          </div>
                        )}
                      </div>
                    </div>

                    {this.state.product.length > 0 && (
                      <div style={{width: '100%'}} className="mt-4">
                        <table className="baseTable mb-0">
                          <tbody>
                            <tr className="firstRow">
                              <td>ردیف</td>
                              <td>تامین کننده</td>
                              <td>کد محصول</td>
                              <td>بارکد محصول</td>
                              <td>نام محصول</td>
                              <td>مقدار</td>
                              <td>واحد</td>
                              <td>تاریخ تولید</td>
                              <td>حذف</td>
                            </tr>
                            {this.state.product.map((items, index) => (
                              <tr key={index}>
                                <td>{this.state.product.length - index}</td>
                                <td>{items.providerName}</td>
                                <td>{items.articleId}</td>
                                <td>{items.productCode}</td>
                                <td>
                                  <a target="_blank" href={productShop({articleId: items.articleId})}>
                                    {items.productName}
                                  </a>
                                </td>
                                <td>
                                  {/*{items.quantity}*/}
                                  <input
                                    className={'countText' + ' ' + 'tableQuantity' + ' ' + items.vahed}
                                    type="text"
                                    value={items.quantity}
                                    onChange={(e) => this.changeCount(index, e.target.value)}
                                    name="quantity"
                                    id={index}
                                  />
                                </td>
                                <td>{items.productUnitTitle}</td>
                                <td className="d-flex flex-row justify-content-between">
                                  <button
                                    onClick={() => this.setNowDateProduct(index)}
                                    className="btn btn-sm btn-success"
                                  >
                                    تاریخ امروز
                                  </button>

                                  <InputMask
                                    autocomplete="off"
                                    placeholder="yyyy/mm/dd"
                                    className="form-control"
                                    style={{width: '80%', display: 'block', margin: 'auto'}}
                                    mask="9999/99/99"
                                    maskChar={null}
                                    onKeyPress={(e) => this.shortKeyManufactorDate(index, e)}
                                    defaultValue={items.manufactureDate}
                                    value={items.manufactureDate}
                                    onChange={(e) => this.changeManufactorDate(index, e.target.value)}
                                  />
                                  {/*<input type={'text'} onChange={(e)=>this.changeManufactorDate(index,e.target.value)} value={items.manufactureDate}/>*/}
                                </td>

                                <td>
                                  <button key={index} onClick={() => this.delete(index)}>
                                    <img src={require('../../image/trash.svg')} alt="" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <Button
                          className="position-sticky mx-0 mt-4"
                          style={{bottom: 10}}
                          onClick={this.Edit.bind(this)}
                        >
                          ویرایش پیش سند
                        </Button>
                        <span className="errorText mb-0">{this.state.addError}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>

            <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <ModalHeader toggle={this.toggle}>محصول خود را جست و جو کنید</ModalHeader>
              <ModalBody>
                <form className="modalForm searchProduct" onSubmit={this.submitForm.bind(this)}>
                  <figure>
                    <label>نام محصول : </label>
                    <input className="form-control" type="text" id="productName" placeholder="نام محصول را وارد کنید" />
                  </figure>
                  <figure>
                    <AutoComplete
                      label="تامین کننده"
                      api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                      textField="title"
                      valueField="providerId"
                      id="provider"
                      value={this.state.providerIdSearch}
                      setValue={(providerIdSearch) => this.setState({providerIdSearch})}
                    />
                    {/* <label>طرف - تامین کننده</label>
                                    <Select
                                        value={this.state.providerIdSearch}
                                        onChange={this.getValueProviderSearch}
                                        options={this.state.providers}
                                        isClearable
                                        placeholder='------'
                                        isDisabled={this.state.providerId === '' || this.state.providerId === null ? false : true}
                                    /> */}
                  </figure>

                  <figure>
                    <label>بارکد محصول:</label>
                    <input
                      className="form-control"
                      type="text"
                      id="productCode"
                      placeholder="بارکد محصول را وارد کنید"
                    />
                  </figure>

                  <figure>
                    <label>کد محصول:</label>
                    <input className="form-control" type="text" id="articleCode" placeholder="کد محصول را وارد کنید" />
                  </figure>

                  <figure>
                    <label className="hiddenLabel">نام تامین کننده:</label>
                    <button
                      onClick={this.searchProduct.bind(this)}
                      className="searchProduct form-control btn btn-primary btn-sm mb-5"
                    >
                      جست و جو
                    </button>
                    <p className="errorText" />
                  </figure>
                </form>
                <div className={tableVisibile}>
                  <div className="tableComponent">
                    <table className="baseTable searchProductTable">
                      <tbody>
                        <tr className="firstRow">
                          <td>ردیف</td>
                          <td>انتخاب</td>
                          <td>نام محصول</td>
                          <td>کد محصول</td>
                          <td>تامین کننده</td>
                          <td>بارکد</td>
                          <td>واحد</td>
                        </tr>
                        {this.state.searchesProduct.map((product, index) => (
                          <tr key={index} onDoubleClick={() => this.double(index)}>
                            <td>{(pageNumber - 1) * 5 + index + 1}</td>
                            <td>
                              <RadioGroup onChange={this.onchangeSearch} value={this.state.search}>
                                <Radio value={index}>انتخاب</Radio>
                              </RadioGroup>
                            </td>
                            <td>
                              <a target="_blank" href={productShop({articleId: product.articleId})}>
                                {product.productName}
                              </a>
                            </td>
                            <td>{product.articleId}</td>
                            <td>{product.providerName}</td>
                            <td>{product.productCode}</td>
                            <td>{product.productUnitTitle}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="paginationWrapp">
                      <Pagination
                        defaultCurrent={1}
                        total={this.state.lengthProducts}
                        onChange={this.onChangePagination.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <button className="confirmBtnModal" onClick={this.handleOk}>
                  تایید
                </button>
                <button className="cancelBtnModal" onClick={this.handleCancel}>
                  لغو
                </button>
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.modalConfirm} toggle={this.cancelConfirm.bind(this)} size="sm">
              <Loader show={this.state.loading} />
              <ModalHeader toggle={this.cancelConfirm.bind(this)}>تاییدیه</ModalHeader>
              <ModalBody>
                <p className="titleSm">آیا از ویرایش پیش سند مطمئن هستید؟؟</p>
              </ModalBody>
              <ModalFooter>
                <button className="confirmBtnModal" onClick={this.EditPreRecord.bind(this)}>
                  ویرایش پیش سند
                </button>
                <button className="cancelBtnModal" onClick={this.cancelConfirm.bind(this)}>
                  لغو
                </button>
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.modalError} toggle={this.cancelError.bind(this)}>
              <Loader show={this.state.loading} />
              <ModalHeader toggle={this.cancelError.bind(this)}>لیست مغایرت ها</ModalHeader>
              <ModalBody>
                <p className="titleSm">{this.state.textUnMatch}</p>
                {this.state.deliveryDates.length > 0 && (
                  <>
                    <p>تاریخ‌(های) تحویل مشتری</p>
                    <table className="baseTable mb-3">
                      <tbody>
                        <tr className="firstRow">
                          <td>ردیف</td>
                          <td>تاریخ</td>
                        </tr>
                        {this.state.deliveryDates.map((date, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{jMoment(date).format('jYYYY/jMM/jDD')}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}

                <div
                  className="unMatchClass"
                  style={this.state.incompatibleRemainProducts.length == '0' ? {display: 'none'} : {display: 'block'}}
                >
                  <p>لیست مغایرت موجودی انبار</p>
                  <table className="baseTable">
                    <tbody>
                      <tr className="firstRow">
                        <td>ردیف</td>
                        <td>نام محصول</td>
                        <td>کد محصول</td>
                        <td>{this.state.checkIsInput ? 'تعداد ورود' : 'تعداد در سند'}</td>
                        <td>تعداد موجودی</td>
                      </tr>
                      {this.state.incompatibleRemainProducts.map((product, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <a target="_blank" href={productShop({articleId: product.articleId})}>
                              {product.title}
                            </a>
                          </td>
                          <td>{product.articleId}</td>
                          <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                            {product.requestedQuantity}
                          </td>
                          <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                            {product.remainQuantity}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div
                  className="unMatchClass"
                  style={
                    this.state.incompatibleSupplyOrderProducts.length == '0' ? {display: 'none'} : {display: 'block'}
                  }
                >
                  <p>لیست مغایرت موجودی سفارش تامین کننده</p>
                  <table className="baseTable">
                    <tbody>
                      <tr className="firstRow">
                        <td>ردیف</td>
                        <td>نام محصول</td>
                        <td>کد محصول</td>
                        <td>{this.state.checkIsInput ? 'تعداد ورود' : 'تعداد در سند'}</td>
                        <td>تعداد سفارش</td>
                      </tr>
                      {this.state.incompatibleSupplyOrderProducts.map((product, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <a target="_blank" href={productShop({articleId: product.articleId})}>
                              {product.title}
                            </a>
                          </td>
                          <td>{product.articleId}</td>
                          <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                            {product.requestedQuantity}
                          </td>
                          <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                            {product.remainQuantity}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {this.state.showClipboardBtn && (
                    <CopyToClipboard
                      text={this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'notShow')}
                      onCopy={() => this.copyClipBoard(this.state.incompatibleSupplyOrderProducts, 'show')}
                    >
                      <span
                        className="my-4 text-white p-2 d-inline-block rounded"
                        style={{background: '#f7941e', cursor: 'pointer'}}
                      >
                        کپی در clipBoard
                      </span>
                    </CopyToClipboard>
                  )}
                </div>

                <div
                  className="unMatchClass"
                  style={this.state.incompatibleDispatchProducts.length == '0' ? {display: 'none'} : {display: 'block'}}
                >
                  <p>لیست مغایرت کالا های توزیع</p>
                  <table className="baseTable">
                    <tbody>
                      <tr className="firstRow">
                        <td>ردیف</td>
                        <td>نام محصول</td>
                        <td>کد محصول</td>
                        <td>{this.state.checkIsInput ? 'تعداد ورود' : 'تعداد در سند'}</td>
                        <td>تعداد توزیع</td>
                      </tr>
                      {this.state.incompatibleDispatchProducts.map((product, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <a target="_blank" href={productShop({articleId: product.articleId})}>
                              {product.title}
                            </a>
                          </td>
                          <td>{product.articleId}</td>
                          <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                            {product.requestedQuantity}
                          </td>
                          <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                            {product.remainQuantity}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div style={this.state.tableNotFound ? {display: 'block'} : {display: 'none'}}>
                  <table className="baseTable">
                    <tbody>
                      <tr className="firstRow">
                        <td>ردیف</td>
                        <td>نام محصول</td>
                        <td>کد محصول</td>
                        <td>بارکد محصول</td>
                      </tr>
                      {this.state.unMatchProduct.map((product, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <a target="_blank" href={productShop({articleId: product.articleId})}>
                              {product.title}
                            </a>
                          </td>
                          <td>{product.articleId}</td>
                          <td>{product.barCode}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </ModalBody>
              <ModalFooter>
                <button
                  className="confirmBtnModal"
                  style={this.state.tableNotFound ? {display: 'none'} : {display: 'block'}}
                  onClick={this.EditFinalyPreRecord.bind(this)}
                >
                  ویرایش پیش سند
                </button>
                <button className="cancelBtnModal" onClick={this.cancelError.bind(this)}>
                  لغو
                </button>
              </ModalFooter>
            </Modal>
          </div>
        ) : null}
      </div>
    )
  }
}

export default EditPreRecord
